import { ICellRendererParams } from "ag-grid-community";
import { Link as RouterLink } from "react-router";
import { useRef } from "react";
import { Link } from "@platform/design-system";

import { ROUTE_NAMES } from "../../../constants";
import { CarrierBonusSummaryApi } from "../types";

export const CarrierLinkCell: React.FC<
  ICellRendererParams<CarrierBonusSummaryApi, string | null>
> = (params) => {
  const brokerId = params.data.broker_id;
  const id = params.data.carrier_id;
  const name = params.valueFormatted ?? params.value ?? "N/A";
  const labelRef = useRef<HTMLAnchorElement | null>(null);

  return (
    <Link
      component={RouterLink}
      to={`/${ROUTE_NAMES.BBE}/${brokerId}/forecast/${ROUTE_NAMES.BBE_CARRIER_BONUS_DETAILS}/${id}`}
      noWrap
      title={name}
      variant="body2"
      ref={labelRef}
    >
      {name}
    </Link>
  );
};
